module.exports = __webpack_public_path__ + "img/group-7.ca838d70.svg";